import { ImportantMessagesWebComponent } from './component/ImportantMessagesWebComponent';
import { WEB_COMPONENT_IMPORTANT_MESSAGES } from '../webcomponents.constants';

export { ImportantMessagesWebComponent };

window.customElements.define(WEB_COMPONENT_IMPORTANT_MESSAGES, ImportantMessagesWebComponent);
